import _ from 'lodash'
import './descriptionCodeField.scss'
import templateUrl from './descriptionCodeField.html'

/**
 * Description + Code Field component
 *
 * @example
 * <tmr-description-code-field resource="$ctrl.resource"></tmr-description-code-field>
 *
 * @type {ngComponent}
 * @prop {boolean=} [focus=false] If true, autofocus on description when empty
 * @prop {TmrResource} resource
 * @prop {boolean=} [sync=true] If false, code field will never sync with description
 * @prop {string=} [descriptionHelp] Translated help text for the description field
 * @prop {string=} [codeHelp] Translated help text for the code field
 */
export const tmrDescriptionCodeField = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrDescriptionCodeFieldController',
  require: {
    resourceForm: '^form',
  },
  bindings: {
    focus: '<',
    resource: '=',
    sync: '@?',
    descriptionHelp: '@?',
    codeHelp: '@?',
  },
}

/**
 * Controller of component {@link tmrDescriptionCodeFieldController}.
 *
 * @type {ngController}
 */
export class tmrDescriptionCodeFieldController {
  static ngType = 'controller'

  $onInit() {
    this.sync = this.sync ?? true
    this.enable =
      this.resource.code === undefined &&
      this.resource.description === undefined
    this.$sync = this.sync && this.enable
  }

  onDescriptionChange() {
    const areEmpty = this.areEmpty()
    if (areEmpty) this.enable = true
    this.$sync = this.sync && (this.$sync || areEmpty)
    if (this.$sync) {
      this.resource.code = _.machineName(this.resource.description)
    }
  }

  isSync() {
    return this.$sync
  }

  onCodeChange() {
    const areEmpty = this.areEmpty()
    if (areEmpty) this.enable = true
    this.$sync = this.sync && this.enable && areEmpty
  }

  areEmpty() {
    return !this.resource.code && !this.resource.description
  }
}
